import { provideHttpClient, withFetch, withInterceptors, withInterceptorsFromDi } from '@angular/common/http'
import {
    ApplicationConfig,
    ErrorHandler,
    inject,
    provideAppInitializer,
    provideZonelessChangeDetection
} from '@angular/core'
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async'
import { provideRouter } from '@angular/router'
import { HeaderInterceptor } from '@isl-core/interceptors/header.interceptor'
import { LoadingInterceptor } from '@isl-core/interceptors/loading.interceptor'
import { ConfigInterface } from '@isl-core/interfaces/config.interface'
import { InitService } from '@isl-core/services/init.service'
import { ThemeService } from '@isl-core/services/theme.service'
import {
    AutoRefreshTokenService,
    CUSTOM_BEARER_TOKEN_INTERCEPTOR_CONFIG,
    customBearerTokenInterceptor,
    provideKeycloak,
    UserActivityService,
    withAutoRefreshToken
} from 'keycloak-angular'
import Keycloak from 'keycloak-js'
import { providePrimeNG } from 'primeng/config'
import { DialogService } from 'primeng/dynamicdialog'
import { routes } from './app.routes'
import CustomPreset from './customPreset'
import { ErrorHandlerService } from '@isl-core/services/error-handler.service'

export const environment: ConfigInterface = (window as unknown as { env: ConfigInterface }).env

export const appConfig: ApplicationConfig = {
    providers: [
        provideAnimationsAsync(),
        providePrimeNG({
            theme: {
                preset: CustomPreset,
                options: {
                    darkModeSelector: 'none'
                }
            }
        }),
        provideHttpClient(
            withFetch(),
            withInterceptorsFromDi(),
            withInterceptors([customBearerTokenInterceptor, LoadingInterceptor, HeaderInterceptor])
        ),
        {
            provide: CUSTOM_BEARER_TOKEN_INTERCEPTOR_CONFIG,
            useValue: [
                {
                    shouldAddToken: async (_: Request, __: Response, keycloak: Keycloak) => {
                        return keycloak.authenticated
                    }
                }
            ]
        },
        provideKeycloak({
            config: {
                realm: environment.KEYCLOAK_REAL,
                url: environment.KEYCLOAK_ENDPOINT,
                clientId: environment.KEYCLOAK_CLIENT_ID
            },
            initOptions: {
                onLoad: 'login-required',
                checkLoginIframe: false
            },
            features: [
                withAutoRefreshToken({
                    onInactivityTimeout: 'logout',
                    sessionTimeout: 36000000
                })
            ],
            providers: [AutoRefreshTokenService, UserActivityService]
        }),
        provideZonelessChangeDetection(),
        provideRouter(routes),
        provideAppInitializer(() => {
            // Services injection
            const initService = inject(InitService)

            // Theme assignment initialization
            inject(ThemeService)

            // First Load configuration
            initService.initApiUrl().initMenu()
        }),
        {
            provide: ErrorHandler,
            useClass: ErrorHandlerService
        },
        DialogService
    ]
}
